// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2ZMCB","alertIcon":"ConfirmModal_alertIcon__2tE0_"};